import React from 'react';
import Grid from '@material-ui/core/Grid';
import Circle from './Circle';

const TEXTS = [
  ['岐阜県の最北端', '富山県に', '隣接しているまち'],
  ['面積：792.5 km²', '総人口：22,585人'],
  ['美しい渓谷や', '日本有数の豪雪地帯で', '自然を満喫'],
  ['昔ながらの里山で', '伝統文化も', '受け継がれている'],
];

const CircleGrid = ({ index }: { index: number | Array<number> }) => {
  return (
    <Grid container spacing={3}>
      {[index].flat().map((idx) => (
        <Grid item key={idx} xs={12}>
          <Circle>
            {TEXTS[idx].map((text, i) => (
              <span key={`${idx}-${i}`}>{text}</span>
            ))}
          </Circle>
        </Grid>
      ))}
    </Grid>
  );
};

export default CircleGrid;
